import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import Cookie from 'utils/cookies';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { UNIFIED_FEED_DOMAIN_SERVICE, TOI_LIVE_DOMAIN } from 'constants/index';
import makeRequest from 'utils/makeRequest';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';

import GameOverlay from '../GameOverlay/GameOverlay';
import { getEdges, getMatrix, createLoopDetector } from './utils';
import HowToPlay from '../HowToPlay/HowToPlay';
import Grid from './Grid/Grid';
import { loadSyncUp, loadLoopaloopStateSave } from '../../../redux';

import s from './LoopALoopGame.scss';
import CongratulationsNew from '../CongratulationsNew/CongratulationsNew';
// import GameCardListing from '../GameCardListing/GameCardListing';
// import PracticeCard from '../PracticeCard/PracticeCard';
import breadcrumbs from '../../../GameBreadcrumbsHelper';
// import BreadCrumb from '../../../../../components_v2/common/BreadCrumb/BreadCrumb';
import ShareButton from '../ShareButton/ShareButton';
import MoreOnGames from '../MoreOnGames/MoreOnGames';
import { fireGa4andGrx, initializeIframeMessageListener, checkIframeUserLogin, timeStringToMilliseconds } from '../../../layouts/utils';

const useGameState = props => {
  const { apiConfigData, puzzleAPI, levelData } = props;
  const configSaveStateCounter = apiConfigData?.saveStateTimerValueInSec || 5;
  const gameId = levelData?.gameID || puzzleAPI?.gameId || '';
  const jsonUrl = levelData?.deeplink || puzzleAPI?.url || '';
  
  // Initialize grxId and ssoId
  let grxId = Cookie.get('_grx') || '';
  let ssoId = Cookie.get('ssoid') || '';

  return { configSaveStateCounter, gameId, jsonUrl, grxId, ssoId, levelData };
};

const isLocalStorageAvailable = () => {
  return typeof localStorage !== 'undefined' && localStorage !== null;
};

const LoopALoopGame = props => {
  const { isMobile, userData, todaysGame, isToday, handleGameCallback, buttonClicked, iframeSource, iframeLangSource, isGameIframe, iframeLang, gameSolutionData, viewSolution, showCongratulationsData, gamejsonUrl, gamesolLevel } = props;
  const {
    configSaveStateCounter,
    gameId,
    jsonUrl,
    grxId,
    ssoId,
    levelData,
  } = useGameState({ ...props });
  const commonTranslations = _get(props, 'gamesconfigData.translations.commonTranslations', {});
  const gameSpecificTranslations = _get(props, 'gamesconfigData.translations.gameSpecificTranslations.loopALoop', {});

  const [showLoader, setLoader] = useState(true);
  const [numbers, setPuzzle] = useState([]);
  const [dim, setDim] = useState([]);
  const [solution, setSolution] = useState([]);
  const [timer, setTimer] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [status, setStatus] = useState('playing');
  const [isTimerVisible, setIsTimerVisible] = useState(() => {
    if (isGameIframe && iframeSource) {
      const iframesrcgames = JSON.parse(localStorage.getItem(`${iframeSource}games`) || '{}');
      return iframesrcgames?.loopalooptimer !== 'off';
    } else if (typeof localStorage !== 'undefined') {
      const toigames = JSON.parse(localStorage.getItem('toigames') || '{}');
      return toigames?.loopalooptimer !== 'off';
    } else {
      return true;
    }
  });
  const [showOverlay, setShowOverlay] = useState(false);
  const [popUpType, setPopUpType] = useState('');
  const [showCongrate, setCongrate] = useState(showCongratulationsData || false);
  const [resultData, setResultData] = useState(undefined);
  const [userEdges, setUserEdges] = useState(undefined);
  const [persentageVal, setPersentageVal] = useState(0);
  const [isHowToPlayVisible, setIsHowToPlayVisible] = useState(false);
  const [submitButtonEnable, setSubmitButtonEnable] = useState(false);
  const [isAutoCheck, setAutoCheck] = useState(false);
  const [isYourLoopActive, setYourLoopActive] = useState(true);
  const [matrix, setMatrix] = useState([]);
  //const [history, setHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(-1);
  const [hasSynced, setHasSynced] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [failedAPI, setFailedAPI] = useState('');

  const timerRef = useRef(null);
  const isPausedRef = useRef(false);
  const userDataRef = useRef(userData);

  // Filtering Coordinates
  const filterValidCoordinates = (edges, puzzleDim) => {
    if (!edges || !Array.isArray(edges) || !puzzleDim || puzzleDim.length < 2) {
      return [];
    }
    const [maxRows, maxCols] = puzzleDim;
    return edges.filter(item => {
      if (!item || !item.a || !item.b || !Array.isArray(item.a) || !Array.isArray(item.b)) {
        return false;
      }
      const [ax, ay] = item.a;
      const [bx, by] = item.b;
      return ax >= 0 && ax <= maxRows && 
             ay >= 0 && ay <= maxCols && 
             bx >= 0 && bx <= maxRows && 
             by >= 0 && by <= maxCols;
    });
  };

  const updateMatrix = useCallback(
    newMatrix => {
      // setHistory(prevHistory => [
      //   ...prevHistory.slice(0, historyIndex + 1),
      //   newMatrix,
      // ]);
      setHistoryIndex(prevIndex => prevIndex + 1);
      setMatrix(newMatrix);
    },
    [historyIndex],
  );

  useEffect(
    () => {
      if (matrix.length) {
        const edgesData = getEdges(matrix);
        if (!showCongrate) {
          if (isLocalStorageAvailable()) {
            if (isGameIframe && iframeSource) {
              localStorage.setItem(
                `${iframeSource}loopaloop:${gameId}`,
                JSON.stringify({ timer, edgesData, isAutoCheck }),
              );
            } else {
              localStorage.setItem(
                `tilloopaloop:${gameId}`,
                JSON.stringify({ timer, edgesData, isAutoCheck }),
              );
            }
          }
        }
        timerRef.current = timer || timerRef.current;
      }
    },
    [matrix, timer],
  );

  const fireGa = (ga4Type, ga4Category, ga4Label) => {
    analyticsWrapper('grx', 'track', 'user_click', {
      event: 'user_click',
      type: ga4Type,
      category: ga4Category,
      label: ga4Label,
    });
  };

  const fireGaGameScreen = (gaLabelText, score = '', gaType) => {
    const gaData = {
      event: 'user_shown_games',
      type: gaType || 'gameplay_screen',
      label: gaLabelText,
      page_template: 'gameplay',
      section: 'games',
      subsection: 'loop_the_loop',
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: levelData?.level?.toLowerCase(),
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    if (score) {
      gaData.score = score;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
  };

  const overlayCall = type => {
    setShowOverlay(true);
    setPopUpType(type);
  };

  const gameStateSaveCall = () => {
    if (
      typeof props.loadLoopaloopStateSave === 'function' &&
      userData?.isLoggedIn &&
      todaysGame
    ) {
      let locatStateData;
      if (isGameIframe && iframeSource) {
        locatStateData = JSON.parse(
          localStorage.getItem(`${iframeSource}loopaloop:${gameId}`),
        );
      } else {
        locatStateData = JSON.parse(
          localStorage.getItem(`tilloopaloop:${gameId}`),
        );
      }
      try {
        const params = {
          gameId,
          gameType: 'loop-a-loop',
          grxId,
          ssoId,
          completionTimeInMillis: (timer || timerRef.current) * 1000,
          loopAloopData: {
            loopData: locatStateData?.edgesData,
            isAutoCheck: locatStateData?.isAutoCheck,
          },
        };
        props.loadLoopaloopStateSave(params);
      } catch (e) {
        console.log('game error>>', e);
      }
    }
  };

  const clearLocalStorage = key => {
    try {
      if (isLocalStorageAvailable()) {
        localStorage.removeItem(key);
      }
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  };

  const gameStateFetchCall = (puzzleDim, puzzleData, solutionData, receivedGrxId, receivedSsoId) => {
    let tempGrxId = grxId;
    let tempSsoId = ssoId;

    if (isGameIframe && iframeLangSource) {
      tempGrxId = receivedGrxId || grxId;
      tempSsoId = receivedSsoId || ssoId;
    }
    if (userData?.isLoggedIn && todaysGame && !showCongrate) {
      let url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/get/paused/game?pc=toi&pfm=web&gameId=${gameId}&gameType=loop_a_loop`;
      if (isGameIframe && iframeLangSource) {
        url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/get/paused/game?pc=${iframeLangSource}${
          iframeLang ? `&lang=${iframeLang}` : ''
        }&pfm=web&gameId=${gameId}&gameType=loop_a_loop`;
      }
      makeRequest
        .post(url, {}, { headers: { grxId: tempGrxId, ssoId: tempSsoId } })
        .then(data => {
          const stateData = data?.data?.stateLoopALoop;
          const stateLoopALoop = stateData?.loopAloopData?.loopData;
          const stateIsAutoCheck = stateData?.loopAloopData?.isAutoCheck;
          const stateLoopALoopTimer = (stateData?.completionTimeInMillis ?? 0) / 1000;
          setTimer(stateLoopALoopTimer);
          setAutoCheck(stateIsAutoCheck ?? false);
          if (!showCongrate) {
            if (isGameIframe && iframeSource) {
              localStorage.setItem(
                `${iframeSource}loopaloop:${gameId}`,
                JSON.stringify({
                  stateLoopALoopTimer,
                  edgesData: stateLoopALoop,
                  isAutoCheck: stateIsAutoCheck,
                }),
              );
            } else {
              localStorage.setItem(
                `tilloopaloop:${gameId}`,
                JSON.stringify({
                  stateLoopALoopTimer,
                  edgesData: stateLoopALoop,
                  isAutoCheck: stateIsAutoCheck,
                }),
              );
            }
          }
          const temp = getMatrix(
            puzzleDim,
            stateLoopALoop,
            puzzleData,
            solutionData,
            stateIsAutoCheck,
          );
          updateMatrix(temp);
          setLoader(false);
        })
        .catch(err => {
          console.log(err);
          setFailedAPI('get_paused_api');
          overlayCall('errorPopUp');
          setLoader(false);
        });
    }
  };

  const getStatusCall = (puzzleDim, puzzleData, solutionData) => {
    setLoader(true);
    let tempGrxId = grxId;
    let tempSsoId = ssoId;

    if (isGameIframe && iframeSource) {
      const cleanup = initializeIframeMessageListener({
        onLoginStatus: data => {
          if (data && data.userData) {
            // Update grxId and ssoId with iframe data if available
            tempGrxId = data?.userData?.grxId || grxId;
            tempSsoId = data?.userData?.userDetails?.ssoid || ssoId;
          }
          cleanup(); // Clean up listener after receiving data
        },
      });
      // Check login status
      checkIframeUserLogin(iframeSource, iframeLang);
      // return cleanup;
    }


    let url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamp/status/game?pc=toi&pfm=web&gameId=${gameId}&gameType=loop_a_loop`;
    if (isGameIframe && iframeLangSource) {
      url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamp/status/game?pc=${iframeLangSource}${iframeLang ? `&lang=${iframeLang}` : ''}&pfm=web&gameId=${gameId}&gameType=loop_a_loop`;
    }
    const requestParams = { params: {}, headers: { grxId: tempGrxId, ssoId: tempSsoId } };
    makeRequest
      .get(url, requestParams, 'skipfeedengine')
      .then(data => {
        if (data?.data?.items) {
          if (data?.data?.hasPlayed) {
            const gameCongratulationsData = data?.data?.items?.find(
              item => item?.tn === 'gameCongratulationsData',
            );
            if (gameCongratulationsData?.gameCongratulationsData) {
              setIsSubmitted(true);
              const loggedInResult = !!(grxId && ssoId);
              setResultData({
                ...gameCongratulationsData?.gameCongratulationsData,
                loggedInResult,
              });
              const achievementCards = gameCongratulationsData?.gameCongratulationsData?.achievementCards;
              const tempGameScore =
                Array.isArray(achievementCards) &&
                achievementCards.length > 0 &&
                typeof achievementCards[0]?.primaryText === 'string' &&
                achievementCards[0].primaryText.trim() !== ''
                  ? timeStringToMilliseconds(achievementCards[0].primaryText)
                  : 'N/A';
            fireGaGameScreen('view_results', tempGameScore, 'results_score');
              setUserEdges(data?.data?.stateLoopALoop?.loopAloopData);
              setStatus('submitted');
            }
            setLoader(false);
            setCongrate(true);
            if (isLocalStorageAvailable()) {
              if (isGameIframe && iframeSource) {
                clearLocalStorage(`${iframeSource}loopaloop:${gameId}`);
              } else {
                clearLocalStorage(`tilloopaloop:${gameId}`);
              }
            }
            return;
          }
          gameStateFetchCall(puzzleDim, puzzleData, solutionData, tempGrxId, tempSsoId);
          setLoader(false);
          fireGaGameScreen(
            buttonClicked === 'resumeButton' ? 'resume_game' : 'start_game',
          );
        }
        try {
          let savedState;
          if (isLocalStorageAvailable()) {
            if (isGameIframe && iframeSource) {
              savedState = localStorage.getItem(`${iframeSource}loopaloop:${gameId}`);
            } else {
              savedState = localStorage.getItem(`tilloopaloop:${gameId}`);
            }
          }
          if (savedState) {
            const localStateData = JSON.parse(savedState);
            const temp = getMatrix(
              puzzleDim,
              localStateData?.edgesData,
              puzzleData,
              solutionData,
              localStateData?.isAutoCheck ?? false,
            );
            setTimer(localStateData?.timer);
            timerRef.current = localStateData?.timer;
            setAutoCheck(localStateData?.isAutoCheck ?? false);
            updateMatrix(temp);
          } else {
            const temp = getMatrix(
              puzzleDim,
              [],
              puzzleData,
              solutionData,
              isAutoCheck,
            );
            updateMatrix(temp);
          }
          gameStateFetchCall(puzzleDim, puzzleData, solutionData, tempGrxId, tempSsoId);
        } catch (error) {
          setFailedAPI('status_api');
          overlayCall('errorPopUp');
          console.error('error inside game js >>', error);
        }
        setLoader(false);
        fireGaGameScreen(
          buttonClicked === 'resumeButton' ? 'resume_game' : 'start_game',
        );
      })
      .catch(err => {
        console.log(err);
        setFailedAPI('status_api');
        overlayCall('errorPopUp');
        setLoader(false);
        fireGaGameScreen(
          buttonClicked === 'resumeButton' ? 'resume_game' : 'start_game',
        );
      });
  };

  const getGameJsonCall = () => {
    makeRequest
      .get(jsonUrl, {}, 'skipfeedengine')
      .then(data => {
        const puzzleData = data?.data?.numbers;
        const puzzleDim = data?.data?.dim;
        const solutionData = data?.data?.solution;
        setPuzzle(puzzleData);
        setDim(puzzleDim);
        setSolution(solutionData);
        getStatusCall(puzzleDim, puzzleData, solutionData);
        setLoader(false);
      })
      .catch(err => {
        console.log(err);
        setFailedAPI('puzzle_api');
        overlayCall('errorPopUp');
        setLoader(false);
      });
  };

  useEffect(() => {
    if (!viewSolution) {
      getGameJsonCall();
    }
  }, [viewSolution]);

  const applySolutionData = (gameSolutionData, puzzleDim, puzzleData, solutionData) => {
    const solutionStateData = gameSolutionData?.stateLoopALoop;
    const solutionLoopALoop = solutionStateData?.loopAloopData;
    const solutionCompletionTime = (solutionStateData?.completionTimeInMillis ?? 0) / 1000;
    if (solutionLoopALoop && Array.isArray(solutionLoopALoop)) {
      setTimer(solutionCompletionTime);
      setUserEdges(solutionLoopALoop);
      setStatus('submitted');
      setIsSubmitted(true);
      
      // Filter out invalid coordinates first
      const validSolutionLoopALoop = filterValidCoordinates(solutionLoopALoop, puzzleDim);
      const array1Keys = new Set(solutionData.map(item => `${item.a}-${item.b}`));
      let commonNodeCount = 0;

      const filteredData = validSolutionLoopALoop
        .filter(item => !item.notAllowed)
        .map(item => {
          const key = `${item.a}-${item.b}`;
          if (array1Keys.has(key)) {
            commonNodeCount += 1;
            return { ...item };
          }
          return { ...item, userInput: true };
        });
      
      const persentage = commonNodeCount / solutionData.length * 100;
      setPersentageVal(Math.round(persentage));
      
      const temp = getMatrix(
        puzzleDim,
        filteredData,
        puzzleData,
        solutionData,
        isAutoCheck,
      );
      updateMatrix(temp);
      setLoader(false);
    }    
  }

  // Fetch puzzle data in solution mode using jsonUrl
  useEffect(() => {
    if (viewSolution && gamejsonUrl) {
      setLoader(true);
      makeRequest
        .get(gamejsonUrl, {}, 'skipfeedengine')
        .then(data => {
          const puzzleData = data?.data?.numbers || [];
          const puzzleDim = data?.data?.dim || [];
          const solutionData = data?.data?.solution || [];
          setPuzzle(puzzleData);
          setDim(puzzleDim);
          setSolution(solutionData);
          applySolutionData(gameSolutionData, puzzleDim, puzzleData, solutionData);
        })
        .catch(err => {
          console.log(err);
          overlayCall('errorPopUp');
          setLoader(false);
        });
    }
  }, [viewSolution, gameSolutionData, gamejsonUrl]);

  useEffect(
    () => {
      if (showCongrate && dim?.length && solution?.length) {
        const edData = getEdges(matrix);
        const edgesData = edData?.length ? edData : userEdges;
        const array1Keys = new Set(solution.map(item => `${item.a}-${item.b}`));
        let commonNodeCount = 0;

        // Check if edgesData exists and is an array before processing
        if (edgesData && Array.isArray(edgesData) && edgesData.length > 0) {
          // Filter out invalid coordinates first
          const validEdgesData = filterValidCoordinates(edgesData, dim);
          
          const filteredData = validEdgesData
            .filter(item => !item.notAllowed)
            .map(item => {
              const key = `${item.a}-${item.b}`;
              if (array1Keys.has(key)) {
                commonNodeCount += 1;
                return { ...item };
              }
              return { ...item, userInput: true };
            });
          const persentage = commonNodeCount / solution.length * 100;
          setPersentageVal(Math.round(persentage));
          const temp = getMatrix(
            dim,
            filteredData,
            numbers,
            solution,
            isAutoCheck,
          );
          updateMatrix(temp);
        }
      }
    },
    [showCongrate, dim, solution],
  );

  const resetConfirmation = () => {
    overlayCall('resetloopaloop');
  };

  const onReset = check => {
    if (check && isLocalStorageAvailable()) {
      let toigames;
      if (isGameIframe && iframeSource) {
        toigames = JSON.parse(localStorage.getItem(`${iframeSource}games`) || '{}');
        toigames.resetPopUpLoopaloop = true;
        localStorage.setItem(`${iframeSource}games`, JSON.stringify(toigames));
      } else {
        toigames = JSON.parse(localStorage.getItem('toigames') || '{}');
        toigames.resetPopUpLoopaloop = true;
        localStorage.setItem('toigames', JSON.stringify(toigames));
      }
    }
    if (dim.length && getEdges(matrix).length) {
      updateMatrix(getMatrix(dim, [], numbers, solution, isAutoCheck));
    }
  };

  const formatTime = time => {
    const hours = String(Math.floor(time / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((time % 3600) / 60)).padStart(2, '0');
    const seconds = String(time % 60).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const startTimer = () => {
    if (timerRef.current) return;

    timerRef.current = setInterval(() => {
      setTimer(prevTimer => {
        const newTimer = prevTimer + 1;
        if (newTimer % configSaveStateCounter === 0) {
          gameStateSaveCall();
        }
        return newTimer;
      });
    }, 1000);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const playTimer = () => {
    if (isPausedRef.current) {
      startTimer();
      isPausedRef.current = false;
    }
  };

  const pauseTimer = () => {
    if (!isPausedRef.current) {
      stopTimer();
      isPausedRef.current = true;
    }
  };

  const hardPause = () => {
    gameStateSaveCall();
    handleGameCallback();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    //fireGa('pause', 'game');
    fireGa4andGrx(
      'pause',
      'user_click_games',
      'gameplay',
      'loop_the_loop',
      isMobile,
      gameId,
      '',
      levelData?.level?.toLowerCase(),
    );
  };

  const manageTimer = () => {
    if (document.visibilityState === 'hidden') {
      if (!isSubmitted && !showCongrate) {
        hardPause();
        pauseTimer();
      }
    } else if (document.visibilityState === 'visible' && !showCongrate) {
      if (!isSubmitted) {
        playTimer();
      }
    }
  };

  useEffect(
    () => {
      if (typeof showCongrate !== 'undefined') {
        document.addEventListener('visibilitychange', manageTimer);

        return () => {
          document.removeEventListener('visibilitychange', manageTimer);
          stopTimer();
        };
      }
    },
    [showCongrate],
  );

  useEffect(
    () => {
      if (status === 'playing' && !isPausedRef.current) startTimer();
      else stopTimer();
      return () => stopTimer();
    },
    [status],
  );

  const handleButtonClick = () => {
    setIsTimerVisible(prev => {
      //fireGa('timer_toggle', 'game', prev ? 'hidden' : 'visible');
      fireGa4andGrx(
        'timer',
        'user_click_games',
        'gameplay',
        'loop_the_loop',
        isMobile,
        gameId,
        prev ? 'off' : 'on',
        levelData?.level?.toLowerCase(),
      );
      const toigames = JSON.parse(localStorage.getItem('toigames') || '{}');
      toigames.loopalooptimer = !prev ? 'on' : 'off';
      localStorage.setItem('toigames', JSON.stringify(toigames));
      return !prev;
    });
  };

  const submitConfirmation = () => {
    overlayCall('submitSudoku');
    //fireGa('submit_game', 'game');
    const gaData = {
      event: 'user_shown_games',
      type: 'submit',
      category: 'submit_popup',
      page_template: 'gameplay',
      section: 'games',
      subsection: 'loop_the_loop',
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: levelData?.level?.toLowerCase(),
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
  };

  const gameOverlayCallback = () => {
    setShowOverlay(false);
  };

  const gameSubmitCall = timeTaken => {
    let url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamp/submit/game?pc=toi&pfm=web&fv=1250&gameId=${gameId}&gameType=loop_a_loop`;
    if (isGameIframe && iframeLangSource) {
      url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamps/submit/game?pc=${iframeLangSource}${
        iframeLang ? `&lang=${iframeLang}` : ''
      }&pfm=web&fv=1250&gameId=${gameId}&gameType=loop_a_loop`;
    }
    const edgesData = getEdges(matrix);
    setUserEdges(edgesData);
    const user = userDataRef.current?.isLoggedIn ? userDataRef.current : {};
    const postData = {
      completionTimeInMillis: timeTaken * 1000,
      userName: user?.getFirstName?.() || 'N/A',
      userImage: user?.getIcon?.() || '',
      loopALoopGameData: { loopAloopData: edgesData },
    };
    setLoader(true);

    let tempGrxId = grxId;
    let tempSsoId = ssoId;

    if (isGameIframe && iframeSource) {
      const cleanup = initializeIframeMessageListener({
        onLoginStatus: data => {
          if (data && data.userData) {
            // Update grxId and ssoId with iframe data if available
            tempGrxId = data?.userData?.grxId || grxId;
            tempSsoId = data?.userData?.userDetails?.ssoid || ssoId;
          }
          cleanup(); // Clean up listener after receiving data
        },
      });
      // Check login status
      checkIframeUserLogin(iframeSource, iframeLang);
      // return cleanup;
    }
    
    makeRequest
      .post(url, postData, { headers: { grxId: tempGrxId, ssoId: tempSsoId } })
      .then(data => {
        if (data?.data?.items) {
          const gameCongratulationsData = data?.data?.items?.find(
            item => item?.tn === 'gameCongratulationsData',
          );
          if (gameCongratulationsData?.gameCongratulationsData) {
            const loggedInResult = !!(grxId && ssoId);
            setResultData({
              ...gameCongratulationsData?.gameCongratulationsData,
              loggedInResult,
            });
            const achievementCards = gameCongratulationsData?.gameCongratulationsData?.achievementCards;
            const tempGameScore =
              Array.isArray(achievementCards) &&
              achievementCards.length > 0 &&
              typeof achievementCards[0]?.primaryText === 'string' &&
              achievementCards[0].primaryText.trim() !== ''
                ? timeStringToMilliseconds(achievementCards[0].primaryText)
                : 'N/A';
            fireGaGameScreen('submit_game', tempGameScore, 'results_score');
          }
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setCongrate(true);
          setLoader(false);
        }
        setLoader(false);
        if (isGameIframe && iframeSource) {
          clearLocalStorage(`${iframeSource}loopaloop:${gameId}`);
        } else {
          clearLocalStorage(`tilloopaloop:${gameId}`);
        }
      })
      .catch(err => {
        console.error(err);
        setFailedAPI('submit_api');
        overlayCall('errorPopUp');
        setLoader(false);
      });
  };

  const submit = () => {
    stopTimer();
    if (!isSubmitted) {
      setIsSubmitted(true);
      setStatus('submitted');
      gameSubmitCall(timer);
    }
  };

  const callonContinue = (type, check) => {
    switch (type) {
      case 'submitConfirmation':
        const gaData = {
          event: 'user_click_games',
          type: 'submit_game',
          category: 'submit_popup',
          label: 'manual_submit',
          page_template: 'gameplay',
          section: 'games',
          subsection: 'loop_the_loop',
          browsing_platform: isMobile ? 'mweb' : 'web',
          game_id: gameId,
          level: levelData?.level?.toLowerCase(),
          game_of_the_day: window.location.href.toLowerCase().includes('/today'),
          score: formatTime(timer),
          login_status: !!ssoId,
          user_grx_id: grxId,
        };
        if (ssoId) {
          gaData.sso_id = ssoId;
        }
        analyticsWrapper('ga4', gaData);
        analyticsWrapper('grx', 'track', 'user_click_games', gaData);
        submit();
        break;
      case 'pausegamepopup':
        playTimer();
        break;
      case 'resetloopaloop':
        onReset(check);
        break;
      default:
        break;
    }
  };
  //const dimClass = dim?.[0] === 5 ? 'medium' : dim?.[0] === 6 ? 'hard' : dim?.[0] === 7 ? 'medium gridSeven' : dim?.[0] === 9 ? 'hard gridNine' : 'easy';

  let dimClass = 'easy';
  if (levelData?.level === 'Medium') {
    dimClass = 'medium';
    if (dim?.[0] === 7) {
      dimClass = 'medium gridSeven';
    }
  } else if (levelData?.level === 'Easy') {
    dimClass = 'easy';
    if (dim?.[0] === 5) {
      dimClass = 'easy gridFive';
    }
  } else if (levelData?.level === 'Hard') {
    dimClass = 'hard';
    if (dim?.[0] === 9) {
      dimClass = 'hard gridNine';
    }
  }
  dimClass = viewSolution && gamesolLevel && gamesolLevel !== '' ? gamesolLevel : dimClass;

  const scrollToHowtoPlay = CTA => {
    setIsHowToPlayVisible(true);
    const targetDiv = document.getElementById('showtoplaycontent');
    if (targetDiv) {
      targetDiv.scrollIntoView({ behavior: 'smooth' });
    } else {
      setTimeout(() => {
        document
          .getElementById('showtoplaycontent')
          .scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  };

  // const breadCrumbData = isToday
  //   ? breadcrumbs?.loopaloopToday || []
  //   : breadcrumbs?.loopaloopPractice || [];

  const handleAutoChecked = e => {
    const edgesData = getEdges(matrix);
    const temp = !!e.target.checked;
    setAutoCheck(temp);
    updateMatrix(getMatrix(dim, edgesData, numbers, solution, temp));
    fireGa4andGrx(
      'auto_check',
      'user_click_games',
      'gameplay',
      'loop_the_loop',
      isMobile,
      gameId,
      temp ? 'on' : 'off',
      levelData?.level?.toLowerCase(),
    );
  };

  useEffect(
    () => {
      if (matrix?.length) {
        const edgesData = getEdges(matrix);
        const loopDetector = createLoopDetector();
        setSubmitButtonEnable(loopDetector.checkForLoops(edgesData));
        if (
          solution?.length &&
          !isSubmitted &&
          loopDetector.checkSolutionMatchesLines(edgesData, solution)
        ) {
          const gaData = {
            event:  'user_click_games',
            type: 'submit_game',
            category: 'auto_submit',
            label: 'auto_submit',
            page_template: 'gameplay' ,
            section: 'games',
            subsection: 'loop_the_loop',
            browsing_platform: isMobile ? 'mweb' : 'web',
            game_id: gameId,
            level: levelData?.level?.toLowerCase(),
            game_of_the_day: window.location.href.toLowerCase().includes('/today'),
            score: formatTime(timer),
            login_status: !!ssoId,
            user_grx_id: grxId,
          };
          if (ssoId) {
            gaData.sso_id = ssoId;
          }
          if (ssoId) {
            gaData.sso_id = ssoId;
          }
          analyticsWrapper('ga4', gaData);
          analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
          submit();
        }
      }
    },
    [matrix],
  );

  const handleResultGrid = isUserData => {
    setYourLoopActive(isUserData);
    const array1Keys = new Set(solution.map(item => `${item.a}-${item.b}`));
    
    // Get userEdges data - either from state or from gameSolutionData when viewSolution is true
    let edgesData = userEdges;
    if (viewSolution && gameSolutionData && (!edgesData || !Array.isArray(edgesData))) {
      const solutionStateData = gameSolutionData?.stateLoopALoop;
      edgesData = solutionStateData?.loopAloopData;
    }
    
    // Filter out invalid coordinates first
    const validEdgesData = filterValidCoordinates(edgesData, dim);
    
    const userEdgetData = validEdgesData
      .filter(item => !item.notAllowed)
      .map(item => {
        const key = `${item.a}-${item.b}`;
        return array1Keys.has(key) ? { ...item } : { ...item, userInput: true };
      });
    const temp = getMatrix(
      dim,
      isUserData ? userEdgetData : solution,
      numbers,
      solution,
      isAutoCheck,
    );
    updateMatrix(temp);
  };

  const gameSyncCall = () => {
    const user = userDataRef.current?.isLoggedIn ? userDataRef.current : {};
    const params = {
      userName: user.getFirstName?.() || 'N/A',
      userImage: user.getIcon?.() || '',
      grxId,
      ssoId,
    };
    props.loadSyncUp(params);
  };

  useEffect(
    () => {
      if (typeof props.loadSyncUp === 'function') {
        userDataRef.current = userData;
        if (userData?.isLoggedIn && !hasSynced) {
          gameSyncCall();
          setHasSynced(true);
        }
      }
    },
    [userData, hasSynced],
  );

  useEffect(() => {
    let timeoutId;
    if (showTooltip) {
      timeoutId = setTimeout(() => {
        setShowTooltip(false);
      }, 10000); // 10 seconds
    }
    
    // Cleanup timeout on component unmount or when tooltip is hidden
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [showTooltip]);


  return (
    <>
    <div
      className={`${s.pageWrapper} ${dimClass} ${
        !showCongrate ? 'loopaloopGame' : s.loopGameCongratsPage
      }`}
    >
      <div className="contentwrapper clearfix">
        {showLoader && (
          <div className={s.loaderouter}>
            <LoaderSpinner />
          </div>
        )}
        {!viewSolution && <>
        {/* {breadCrumbData && !showCongrate &&
          !isMobile && !isGameIframe && (
            <BreadCrumb data={breadCrumbData} wrapperClass="breadcrumb" />
          )} */}
        {!showCongrate && 
        <div className={s.title}>
          <h1>
            {props.gamesmetawidget?.metaInfo?.TemplateH1TopHeading?.value}
          </h1>
          {!isGameIframe &&!isMobile && (
            <ShareButton
              url={`${TOI_LIVE_DOMAIN}/games/loop-a-loop/today`}
              gaCat="Sudoku"
              gaOnClick={() => {
                fireGa('share', 'game');
              }}
            />
          )}
        </div>}
        {showOverlay && (
          <GameOverlay
            isGameIframe={isGameIframe}
            iframeSource={iframeSource}
            iframeLangSource={iframeLangSource}
            iframeLang={iframeLang}
            commonTranslations={commonTranslations}
            gameSpecificTranslations={gameSpecificTranslations}
            popUpType={popUpType}
            gameOverlayCallback={gameOverlayCallback}
            callonContinue={callonContinue}
            gameType="loopaloop"
            gameId={gameId}
            gameLevel={levelData?.level?.toLowerCase()}
            isMobile={isMobile}
            failedAPI={failedAPI}
          />
        )}
        </>}
        {!showCongrate && (
          <div id="til4-timeBlock" className={s.timeBlock}>
            <div className={s.left}>
              {isTimerVisible && <strong>{formatTime(timer)}</strong>}
            </div>
            <div className={s.right}>
              <div className={s.actionWrap}>
                <div
                  className={`${s.circle} ${!isTimerVisible ? s.active : ''}`}
                  onClick={handleButtonClick}
                >
                  <i className={`${s.icon} ${s.timer}`} />
                  <span className={s.switch}>
                    {isTimerVisible ? gameSpecificTranslations.timer.on : gameSpecificTranslations.timer.off}
                  </span>
                </div>
                <div
                  className={s.circle}
                  onClick={() => !isSubmitted && hardPause()}
                >
                  <i className={`${s.icon} ${s.pause}`} />
                </div>
                <div
                  className={s.circle}
                  onClick={() => {
                    if (!isSubmitted) {
                      let storedValue;
                      if (isGameIframe && iframeSource) {
                        storedValue = JSON.parse(
                          localStorage.getItem(`${iframeSource}games`) || '{}',
                        )
                      } else {
                        storedValue = JSON.parse(
                          localStorage.getItem('toigames') || '{}',
                        )
                      }
                      if (storedValue.resetPopUpLoopaloop) {
                        onReset();
                        fireGa4andGrx(
                          'play_again',
                          'user_click_games',
                          'gameplay',
                          'loop_the_loop',
                          isMobile,
                          gameId,
                          '',
                          levelData?.level?.toLowerCase(),
                        );
                        return;
                      }
                      resetConfirmation();
                      fireGa4andGrx(
                        'play_again',
                        'user_click_games',
                        'gameplay',
                        'loop_the_loop',
                        isMobile,
                        gameId,
                        '',
                        levelData?.level?.toLowerCase(),
                      );
                    }
                  }}
                >
                  <i className={`${s.icon} ${s.reset}`} />
                </div>
                {isMobile && (
                  <div
                    className={s.circle}
                    onClick={() => {
                      if(!isSubmitted) { 
                        scrollToHowtoPlay()
                        const gaData = {
                          event:  'user_click_games',
                          type: 'how_to_play',
                          category: 'help_bar',
                          page_template: 'gameplay' ,
                          section: 'games',
                          subsection: 'loop_the_loop',
                          browsing_platform: isMobile ? 'mweb' : 'web',
                          game_id: gameId,
                          level: levelData?.level?.toLowerCase(),
                          game_of_the_day: window.location.href.toLowerCase().includes('/today'),
                          login_status: !!ssoId,
                          user_grx_id: grxId,
                        };
                        if (ssoId) {
                          gaData.sso_id = ssoId;
                        }             
                      analyticsWrapper('ga4', gaData);
                      analyticsWrapper('grx', 'track', 'user_click_games', gaData);
                    }}}
                  >
                    <i className={`${s.icon} ${s.question}`} />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {showCongrate && viewSolution && (
          <div className={s.scoreBanner}>
            <div className={s.loopSwitch}>
              <span
                onClick={() => handleResultGrid(true)}
                className={`${isYourLoopActive ? s.active : ''}`}
              >
                {gameSpecificTranslations.buttons.yourLoop || 'Your Loop'}
              </span>
              <span
                onClick={() => handleResultGrid(false)}
                className={`${!isYourLoopActive ? s.active : ''}`}
              >
                {gameSpecificTranslations.buttons.correctLoop || 'Correct Loop'}
              </span>
            </div>
            <div className={s.scoreValue}>
              {gameSpecificTranslations.messages.percentageCorrect.replace('{percentage}', persentageVal)}
            </div>
          </div>
        )}
        {(!showCongrate || viewSolution) && !showLoader &&
        <div className={s.loopaloopWrap}>
          <div className={s.loopaloop}>
            <div className={s.loopaloopContainer}>
              <Grid
                matrix={matrix}
                setMatrix={updateMatrix}
                isShowCongrate={showCongrate}
                className={`${showCongrate ? 'eventPointerActive' : ''} ${
                  isAutoCheck ? 'autoCheckActive' : ''
                }`}
                solution={solution}
                isAutoCheck={isAutoCheck}
              />
            </div>
            {!showCongrate && (
              <div className={`${s.autocheckLink} autocheckLink`}>
                <div className={s.autoCheck}>
                  <label htmlFor="autoCheckInput">
                    {gameSpecificTranslations.messages.autoCheck.label || 'Auto Check'}
                    <input
                      id="autoCheckInput"
                      type="checkbox"
                      checked={isAutoCheck}
                      onChange={handleAutoChecked}
                    />
                    <i className={s.tickIcon} />
                  </label>
                  <div className={s.toolTipInfo}>
                    <i 
                      className={s.info} 
                      onClick={() => {if(isMobile){setShowTooltip(!showTooltip)}}}
                    />
                    <div className={`${s.toolTipContent} ${showTooltip ? s.toolTipActive : ''}`}>
                      {gameSpecificTranslations.messages.autoCheck.tooltip}
                    </div>
                  </div>
                </div>
                <div className={s.actionLinks} onClick={()=>{
                  const gaData = {
                    event: 'user_click_games',
                    type: 'submit',
                    category: 'popup',
                    page_template: 'gameplay',
                    section: 'games',
                    subsection: 'loop_the_loop',
                    browsing_platform: isMobile ? 'mweb' : 'web',
                    game_id: gameId,
                    level: levelData?.level?.toLowerCase(),
                    game_of_the_day: window.location.href.toLowerCase().includes('/today'),
                    login_status: !!ssoId,
                    user_grx_id: grxId,
                  };
                  if (ssoId) {
                    gaData.sso_id = ssoId;
                  }
                  analyticsWrapper('ga4', gaData);
                  analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
                  submitConfirmation();
                  }}>
                  <button className={`${submitButtonEnable ? s.active : ''}`}>
                    {gameSpecificTranslations.buttons.submit || 'Submit'}
                  </button>
                </div>
              </div>
            )}
          </div>
          {!showCongrate &&
            !isHowToPlayVisible &&
            isMobile && (
              <div className={s.clickLink}>
                <span onClick={() => { 
                  scrollToHowtoPlay('CTA')
                  const gaData = {
                    event: 'user_click_games',
                    type: 'how_to_play',
                    category: 'below_puzzle',
                    page_template: 'gameplay',
                    section: 'games',
                    subsection: 'loop_the_loop',
                    browsing_platform: isMobile ? 'mweb' : 'web',
                    game_id: gameId,
                    level: levelData?.level?.toLowerCase(),
                    game_of_the_day: window.location.href.toLowerCase().includes('/today'),
                    login_status: !!ssoId,
                    user_grx_id: grxId,
                  };
                  if (ssoId) {
                    gaData.sso_id = ssoId;
                  }
                  analyticsWrapper('ga4', gaData);
                  analyticsWrapper('grx', 'track', 'user_click_games', gaData);
                  }}>
                  How to Play
                </span>
              </div>
            )}
          {((!isMobile || isHowToPlayVisible) && (!showCongrate && !viewSolution)) && (
            <div className={s.loopaloopHowtoplay} id="showtoplaycontent">
              <div className={s.howPlayBlock}>
                <div className={s.title}>
                  <h2>{gameSpecificTranslations.messages.howToPlayTitle || `How to play?`}</h2>
                </div>
                <div className={`${s.howPlayOuter} ${s.br16}`}>
                  <HowToPlay gameType="loopaloop" gaLevel={levelData?.level?.toLowerCase()} />
                </div>
              </div>
            </div>
          )}
        </div>
        }
      </div>
    </div>
    {!viewSolution && resultData && (
          <CongratulationsNew
            iframeSource={iframeSource}
            iframeLangSource={iframeLangSource}
            isGameIframe={isGameIframe}
            iframeLang={iframeLang}
            resultData={resultData}
            gameId={gameId}
            showCongrate={showCongrate}
            type="loop-a-loop"
            subType={levelData?.level?.toLowerCase()}
            playAgainCheck={buttonClicked === 'viewResult' ? '' : false}
            buttonClicked={buttonClicked}
            isMobile={isMobile}
            gamejsonUrl={jsonUrl}
          />
        )}
        <div className={s.gameCardAreaWrapper}>
        {!isGameIframe && showCongrate && !viewSolution && (
          <div className={s.gameCardArea}>
            <div className={s.gameWidget}>
              {/* <div className={s.practiceCard}>
                <PracticeCard gameType="loop-a-loop"
                isLargeCard={!isMobile} 
                subType={levelData?.level?.toLowerCase()}
                ga4Category="congratulations"
                gameId={gameId}
                isMobile={isMobile}
                gameLevel={levelData?.level?.toLowerCase()}
                />
              </div> */}
              <MoreOnGames
                    gameType="loop-a-loop"
                    isMobile
                    forceLoadDataOnInit
                    isCogratulationsPage
                    cardProps={{ ga4Category: 'congratulations' }}
                    gameId={gameId}
                    gameLevel={levelData?.level?.toLowerCase()}
                    moreOnGamesTitle="Explore More Games"
                  />
              {/* <div className={s.gameCardList}>
                <GameCardListing
                  cardsIncluded={['crossword', 'mini_crossword']}
                  forceLoadDataOnInit
                  isCogratulationsPage
                  cardProps={{ ga4Category: 'congratulations' }}
                  loaderClass={
                    isMobile
                      ? 'congratulations_mobile'
                      : 'congratulations_desktop'
                  }
                />
              </div> */}
            </div>
          </div>
        )}
        </div>
        
    </>
  );
};

LoopALoopGame.propTypes = {
  isMobile: PropTypes.bool,
  puzzleAPI: PropTypes.shape({}),
  isToday: PropTypes.bool,
  loadLoopaloopStateSave: PropTypes.func,
};

LoopALoopGame.defaultProps = {
  isMobile: false,
  puzzleAPI: {},
  isToday: false,
  loadLoopaloopStateSave: () => {},
};

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  isMobile: state.isMobile,
  isFrmapp: state.isFrmapp,
  puzzleAPI: _get(state, 'toigames.puzzledata', ''),
  gamesmetawidget: _get(state, 'toigames.gamesmetawidget', {}),
  userData: state.login.userData,
  todaysGame: _get(state, 'toigames.puzzledata.todaysGame', ''),
  gamesconfigData: _get(state, 'toigames.gamesconfig', {}),
  apiConfigData: _get(
    state,
    'toigames.gamesconfig.gameCategories.loop_a_loop',
    '',
  ),
});

const mapDispatchToProps = dispatch => ({
  loadSyncUp: params => {
    dispatch(loadSyncUp(params));
  },
  loadLoopaloopStateSave: params => {
    dispatch(loadLoopaloopStateSave(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LoopALoopGame);
